import { Guid, Nillable } from '@web/utils';
import { SalesType } from '@web/shared/module/shop';
import { AdminProductStatus } from '../enums/admin-product-status';

export class AdminProductCollectionItem {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      cosmeticBrandId?: Nillable<Guid>;
      cosmeticBrandName?: Nillable<string>;
      createdAt: Date;
      featuredFileAlt?: Nillable<string>;
      featuredFileUrl?: Nillable<string>;
      id: Guid;
      name: string;
      type: SalesType;
      price?: Nillable<number>;
      availableQuantity?: Nillable<number>;
      slug: string;
      status: AdminProductStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get type(): SalesType {
    return this.data.type;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get cosmeticBrandId(): Nillable<Guid> {
    return this.data.cosmeticBrandId;
  }

  public get cosmeticBrandName(): Nillable<string> {
    return this.data.cosmeticBrandName;
  }

  public get featuredFileUrl(): Nillable<string> {
    return this.data.featuredFileUrl;
  }

  public get featuredFileAlt(): Nillable<string> {
    return this.data.featuredFileAlt;
  }

  public get price(): Nillable<number> {
    return this.data.price;
  }

  public get availableQuantity(): Nillable<number> {
    return this.data.availableQuantity;
  }

  public get status(): AdminProductStatus {
    return this.data.status;
  }

  public get shopPreviewUrl(): string {
    return this.data.slug;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }
}
